import PropTypes from "prop-types";
import React from "react";

import {
  Button,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  TextField
} from "@material-ui/core";

const SearchBar = props => (
  <div
    style={{
      display: "flex",
      marginTop: "10px"
    }}
  >
    <TextField
      disabled={props.usingTextArea}
      style={{ flex: 1 }}
      type="search"
      label="Search"
      value={props.formJsonModalSearchText}
      onChange={e => props.onChangeSearchText(e.target.value)}
    />
    <Button
      disabled={props.usingTextArea}
      style={{ textAlign: "left" }}
      onClick={() => props.onChangeSearchText("")}
    >
      x
    </Button>
    {/* margintop hack to get textfield and select to align..  */}
    <FormControl style={{ marginTop: "40px" }}>
      <Select
        style={{ marginTop: "-25px" }}
        value={props.jsonModalDisplayLevels}
        onChange={e => props.onJSONModalChangeDisplayLevels(e.target.value)}
        disabled={
          props.formJsonModalSearchText.length > 0 || props.usingTextArea
        }
      >
        <MenuItem value={3}>1</MenuItem>
        <MenuItem value={4}>2</MenuItem>
        <MenuItem value={5}>3</MenuItem>
        <MenuItem value={999}>Expand All</MenuItem>
      </Select>
      <FormHelperText>Display levels</FormHelperText>
    </FormControl>
  </div>
);
SearchBar.propTypes = {
  jsonModalDisplayLevels: PropTypes.number.isRequired,
  onJSONModalChangeDisplayLevels: PropTypes.func.isRequired,
  onChangeSearchText: PropTypes.func.isRequired,
  formJsonModalSearchText: PropTypes.string.isRequired,
  usingTextArea: PropTypes.bool.isRequired
};

export default SearchBar;
